var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0EF1BC",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M20 22v3.081c-.8 2.8-8.4 3.2-10 0V22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0BC196",
    strokeWidth: 2,
    d: "M20 21.682c0 .334-.27.87-1.228 1.38-.914.487-2.246.82-3.772.82-1.526 0-2.858-.333-3.772-.82-.957-.51-1.228-1.046-1.228-1.38 0-.335.27-.87 1.228-1.38.914-.488 2.246-.82 3.772-.82 1.526 0 2.858.332 3.772.82.957.51 1.228 1.045 1.228 1.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A0F7E6",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M25 17.5V9.25a4.75 4.75 0 0 0-4.75-4.75v0a4.75 4.75 0 0 0-4.75 4.75V11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0BC196",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m11 11 3.464 3.909c.517.583 1.425.59 1.951.014L20 11"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashback);
export default __webpack_public_path__ + "static/media/cashback.e4b28cc41d59aa11cccc7082797ed356.svg";
export { ForwardRef as ReactComponent };